import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import Results from "@/pages/Results";
import { TopBar } from "@/components/Layout";
import { useTranslation } from "react-i18next";

export default function SharedResults() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { t, i18n } = useTranslation();
  const [study, setStudy] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (!token) { setErr("invalid"); return; }
    const lang = (i18n.language || "fr").split("-")[0];
    api.get(`/study/${encodeURIComponent(token)}`, { params: { lang } })
      .then((r) => setStudy(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || e.message || "Erreur"));
  }, [token, i18n.language]);

  if (err) {
    return (
      <div className="min-h-screen bg-slate-50">
        <TopBar />
        <div className="mx-auto max-w-3xl px-6 py-24 text-center">
          <h2 className="section-h">{t("shared_results.error_title")}</h2>
          <p className="mt-3 text-slate-600">{err === "invalid" ? t("wizard.resume_invalid") : String(err)}</p>
        </div>
      </div>
    );
  }
  if (!study) {
    return (
      <div className="min-h-screen bg-slate-50">
        <TopBar />
        <div className="mx-auto max-w-3xl px-6 py-24 text-center">
          <p className="text-slate-500" data-testid="shared-loading">{t("wizard.loading")}</p>
        </div>
      </div>
    );
  }
  return <Results dataOverride={study} />;
}
